"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const class_transformer_1 = require("class-transformer");
// noinspection JSUnusedGlobalSymbols
class PredicateTree {
    constructor(predicateConfig) {
        this.initChildren(predicateConfig);
    }
    /**
     * Sets children property. Also binds "parent" property of each child to "this" context
     * @param predicateConfig
     * @private
     */
    initChildren(predicateConfig) {
        var _a, _b;
        if (predicateConfig.type === 'ATOMIC' && ((_a = predicateConfig.children) === null || _a === void 0 ? void 0 : _a.length) > 0) {
            throw new Error('Invalid Predicate configuration: ATOMIC predicates cannot have children.');
        }
        this.children = [];
        if ((_b = predicateConfig.children) === null || _b === void 0 ? void 0 : _b.length) {
            // @ts-ignore
            predicateConfig.children.forEach(child => this.appendChild(child));
        }
    }
    /**
     * Overwrites the predicates children
     * @param children
     */
    setChildren(children) {
        [...this.children].forEach(child => child.remove());
        children.forEach(child => this.appendChild(child));
    }
    /**
     * Appends a child predicate as last element
     * @param predicate
     */
    appendChild(predicate) {
        predicate.parent = this;
        this.children.push(predicate);
    }
    /**
     * Finds a direct descendant
     * @param findFunction
     */
    findChild(findFunction) {
        for (let i = 0; i < this.children.length; i++) {
            const child = this.children[i];
            const isFound = findFunction(child);
            if (isFound) {
                return child;
            }
        }
        return null;
    }
    /**
     * Removes predicate from tree. Cannot be executed on root element.
     * The removed predicate becomes the root of its descendants.
     */
    remove() {
        if (this.isRoot()) {
            throw new Error('Root predicate cannot be removed');
        }
        const index = this.parent.children.findIndex(child => child === this);
        this.parent.children.splice(index, 1);
        this.parent = undefined;
    }
    traverseTreeTopToBottom(callback) {
        callback(this);
        if (this.hasChildren()) {
            this.children.forEach((child) => {
                child.traverseTreeTopToBottom(callback);
            });
        }
    }
    traverseTreeBottomToTop(callback) {
        if (this.hasChildren()) {
            this.children.forEach((child) => {
                child.traverseTreeBottomToTop(callback);
            });
        }
        callback(this);
    }
    /**
     * Sets parent relationship
     * Caution, results in circular object
     */
    updateParentProperties() {
        if (this.hasChildren()) {
            this.children.forEach(child => {
                child.parent = this;
                child.updateParentProperties();
            });
        }
    }
    withoutCircularReferences() {
        const copy = (0, class_transformer_1.classToClass)(this, { excludePrefixes: ['parent'] });
        copy.removeParentProperties();
        return copy;
    }
    /**
     * Removes parent relationships. Deprecated as it manipulates the instance
     * Use `withoutCircularReferences` instead
     * @deprecated
     */
    removeParentProperties() {
        if (this.hasChildren()) {
            this.children.forEach((child) => {
                child.parent = null;
                child.removeParentProperties();
            });
        }
    }
    // getters
    hasChildren() {
        return this.children && this.children.length > 0;
    }
    hasMultipleChildren() {
        return this.children && this.children.length > 1;
    }
    isRoot() {
        return this.parent === undefined;
    }
    getSiblings() {
        if (!this.parent) {
            return [];
        }
        return this.parent.children.filter(child => child !== this);
    }
    getParent() {
        return this.parent;
    }
    getChildren() {
        return this.children;
    }
}
exports.default = PredicateTree;
//# sourceMappingURL=PredicateTree.js.map